import { inject, Injectable } from '@angular/core';

import { Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { JobsActions } from '@core/offers-data';
import { StatusChangeType } from '@core/offers-types';

@Injectable({ providedIn: 'root' })
export class ArchiveJobFacade {
  private readonly store = inject(Store);
  private readonly actions = inject(Actions);

  public readonly statusChangeSuccess$ = this.actions.pipe(ofType(JobsActions.changeStatusSuccess));

  public archive(id: number) {
    this.store.dispatch(
      JobsActions.changeStatus({
        payload: { id, status: StatusChangeType.Archive },
      }),
    );
  }
}
